export const MESSAGES = {
  serverWake: "🚀 Server may take 1–2 minutes to wake up.",
  loginSuccess: "Welcome back 🎉",
  loginError: "Invalid Credentials. Please try again.",
  registerSuccess:"Account created successfully! Please login.",
  registerError:"Registration failed. Please try again.",
  productUpdated: "Product updated successfully",
  sellerLoadError:"Failed to load seller profile",
  noImage:"No Image Available",
  unknownCategory:"Uncategorized",
  unknownLocation:"Unknown"

};
export const UI_TEXT = {
  contactSubtitle: "Questions or feedback? We'd love to hear from you.",
  contactEmail: "support@ramtekbazar.com",
  headquarters: "Ramtek, Maharashtra",
  developerCredit: "Developed by Ramtek Dev Team",
};